// extracted by mini-css-extract-plugin
export default {"root":"Search_root__ifu75","input":"Search_input__MspfS","searchBtn":"Search_searchBtn__F4Fg3"};